
import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'

import navigation from '@/navigation'

import { useAuth } from '@/Hooks/UseAuth'
import useTranslation from '@/Hooks/UseTranslation'
import { useProject } from '@/Hooks/UseProject'

import GanttHelper from '@/Helpers/GanttHelper'

import InterfaceActions from '@/Redux/Actions/InterfaceActions'
import TasksActions from '@/Redux/Actions/TasksActions'

import UserAvatar from '@/Components/UserAvatar/UserAvatar'
import LastChanges from '@/Components/LastChanges/LastChanges'
import { getStatusName } from '@/Components/TaskManager/TaskEditorHelper'
import ProjectLayout from '@/Layouts/MainLayout/ProjectLayout'
import ContentBody from '@/Layouts/MainLayout/components/ContentBody'
import TasksHeader from '@/Pages/ProjectTasksPage/TasksHeader'

const ProjectTasksArchivePage = (props: any) => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { userData } = useAuth()

  const { project_id, project } = useProject()

  const tasksReducer = useSelector((state: any) => state.TasksReducer)

  const [taskEditor, setTaskEditor] = useState({
    show: false,
    task: {
      versions: []
    },
  })

  const [showLastChanges, setShowLastChanges] = useState({
    show: false,
    versions: [],
  })

  const [taskList, setTaskList] = useState([])

  const [menu, submenu] = navigation.getNavigation(
    project_id,
    'tasks',
    'archive'
  )

  const loadArchive = async () => {

    await dispatch(TasksActions.getArchive(props.match.params._id))

    dispatch(InterfaceActions.hideLoader())
  }

  const getTasks = () => {

    const tasks: any = []

    tasksReducer.archive.map((_task: any) => {

      const task: any = GanttHelper.getMacroTaskItem({ task: _task }, false)

      task.versions = _task.versions

      tasks.push(task)
    })

    setTaskList(tasks)
  }

  const getRowStyles = (task: any) => {

    const styles: any = {}

    if (task._task.deleted) {

      styles['color'] = 'var(--gantt-day-sunday-border)'
    }

    return styles
  }

  const getTitleStyles = (task: any) => {

    const styles: any = {}

    if (task._task.deleted) {

      styles['textDecoration'] = 'line-through'
    }

    return styles
  }

  const showDiffLastChanges = (task: any) => {

    setShowLastChanges({ ...showLastChanges, versions: task._task.versions, show: true })
  }

  useEffect(() => {

    if (project._id) {

      loadArchive()
    }
  }, [project])

  useEffect(() => {

    getTasks()
  }, [tasksReducer.archive])

  return (
    <ProjectLayout menuName="tasks" subMenuName="archive" hideSubMenu>
      <TasksHeader
        activeTab="archive"
        projectId={project_id}
        subtitle={`Tareas · ${project.name || ''}`}
      />
      <ContentBody>
        <Card className='table-card mb-2'>
          <div>
            <div className="table-responsive">
              <table className="table card-table pl4-tasks-archive-table">
                <thead>
                  <tr>
                    <th style={{ minWidth: 20 }}>#</th>
                    <th style={{ minWidth: 120 }}>
                      {t('TASKS_ARCHIVE:ListStatusHeader')}
                    </th>
                    <th>
                      {t('TASKS_ARCHIVE:ListNameHeader')}
                    </th>
                    <th>
                      {t('TASKS_ARCHIVE:ListResponsiblesHeader')}
                    </th>
                    <th>
                      {t('TASKS_ARCHIVE:ListLastUpdateHeader')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {taskList.map((task: any, i: number) => (
                    <tr key={`${task._id}${i}`} style={getRowStyles(task)}>
                      <td>
                        {i + 1}
                      </td>
                      <td>
                        {task._task.deleted && t('TASKS_ARCHIVE:ListDeletedItem')}
                        {!task._task.deleted && (
                          <span className={`text-color-${task._task.status}`}>
                            {getStatusName(task.status)}
                          </span>
                        )}
                      </td>
                      <td>
                        <div className="archive-task-name"
                          style={getTitleStyles(task)}
                        >
                          {task.title} {task.task_type === 'hito' && t('TASKS_ARCHIVE:ListMilestoneItem')}
                        </div>
                      </td>
                      <td>
                        {task.responsibles.map((user: any, j: number) => (
                          <UserAvatar key={j} user={user} size="sm" />
                        ))}
                      </td>
                      <td>
                        <button className="btn btn-link btn-link-header pl4-btn pl4-btn-secondary pl4-btn-sm"
                          aria-label={`${t('TASKS_ARCHIVE:ListLastUpdateHeader')}: ${task.title || ''}, ${moment(task._task.updatedAt).format('DD/MM/YYYY h:mm a')}`}
                          onClick={() => showDiffLastChanges(task)}
                        >
                          <span className="icon-filtro"></span>
                          <span className="d-none d-md-inline"> {' '}
                            {moment(task._task.updatedAt).format('DD/MM/YYYY h:mm a')}
                          </span>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Card>
      </ContentBody>

      {showLastChanges.show && (
        <LastChanges
          show={showLastChanges.show}
          versions={showLastChanges.versions}
          onHide={() => setShowLastChanges({ ...showLastChanges, versions: [], show: false })}
        />
      )}
    </ProjectLayout>
  )
}

export default ProjectTasksArchivePage
